<template>
  <header id="top-header">
    <article class="util">
      <div>
        <button @click="btnLogo_click">
          <span class="material-icons md-60">home</span>
        </button>
      <template v-if="!$mber.isLgin">
        <button @click="btnMberSbsr_click">
          <span>회원가입</span>
        </button>
        <button @click="btnLgin_click">
          <span>로그인</span>
        </button>
      </template>
      <template v-if="$mber.isLgin">
        <span class="user"
              style="cursor: pointer;"
              @click="btnMyInfo_click">
          {{ $mber.mberNm }}님
        </span>
        <button @click="btnFcltySvc_click">
          <span>시설/서비스</span>
        </button>
        <button @click="btnLgout_click">
          <span>로그아웃</span>
        </button>
      </template>
        </div>
    </article>
    <div class="gnb-wrap">
      <section class="gnb">
        <h1 @click="btnLogo_click">
          <a href="javascript:;">
            <img src="@/assets/img/common/img-gnb-logo.png" alt="SEROI"/>
          </a>
        </h1>
        <nav>
          <ul>
            <li v-for="{sn, nm} in upprMenus"
                :key="'uppr_' + sn">
              <button :class="upprSn == sn ? 'current':''"
                      @click="btnMenu_click(sn)">
                <span>{{ nm }}</span>
              </button>
              <div v-if="$menu.gets(sn).length > 1">
                <button v-for="info in $menu.gets(sn)"
                        :key="'menu_' + info.sn"
                        @click="btnUpprMenu_click(info.path)">
                  <span>{{ info.nm }}</span>
                </button>
              </div>
            </li>
          </ul>
        </nav>
        <button v-if="$mber.isLgin" @click="btnSeroiExec_click">
          <span>세로이 실행</span>
        </button>
      </section>
    </div>
  </header>
</template>

<script setup>
import MyHome from "@/views/my-home/my-home.vue";
import MberInfo from "@/views/my-info/mber-info.vue";
import MberFcltyNvtns from "@/views/my-home/mber-fclty-nvtns.vue";
import SeroiSvcWait from "@/views/svc/seroi-svc-wait.vue";
//import {useSessionStorage} from "@vueuse/core";

import {computed} from "vue";

import {getStore, getUtils} from "@/utils/import";
const {$router, $alert, $popup, $menu, $cmmn, $cmmnPopup, $axios} = getUtils();
const {$loading, $mber} = getStore();

const upprSn = computed(() => $menu.upprSn.value);
const upprMenus = $menu.getUpprs();

const btnMenu_click = (sn) => {
  if (upprSn.value == sn) return false;

  $menu.setUpprSn(sn);
  const info = upprMenus.find(({sn: srchMenuSn}) => srchMenuSn == sn);

  if (!info || !info.path) return false;

  moveScrn(info.path);
};

const btnUpprMenu_click = (path) => {
  moveScrn(path);
}

const btnLogo_click = () => {
  moveScrn('/main');
}

const btnMberSbsr_click = () => {
  moveScrn('/mber-sbsr');
}

const moveScrn = (path) => {
  $router.push({path}).catch(() => {});
}

const btnLgin_click = () => {
  $cmmnPopup.lginShow();
}

const btnMyInfo_click = () => {
  const popupOpts = {
    header: '내정보',
    contentStyle: {
      'width': '800px',
      'max-height': '660px',
      'overflow': 'auto',
    }
  }

  $popup.show(MberInfo, popupOpts);
}

const getFcltysByMberSn = async () => {
  const getFcltysParams = {
    mberSn: $mber.mberSn,
    svcId: $cmmn.svc.getSeroiSvcId(),
  }

  const fcltys = await $cmmn.fclty.getFcltysByMberSn(getFcltysParams);
  return fcltys;
}

const btnFcltySvc_click = async () => {
  try {
    $loading.on();

    const [fcltys, nvtnCnt] = await Promise.all([getFcltysByMberSn(), $cmmn.fclty.getFcltyMberNvtnCntByMberSn($mber.mberSn)]);

    const fcltyCnt = fcltys.length;

    if (fcltyCnt == 1) {
      const fcltySn = fcltys[0].fcltySn;
      openFcltSvcPopup({fcltySn});
    } else $cmmnPopup.fcltyChocShow(openFcltSvcPopup);

    // 시설 초대 내역 팝업
    if (nvtnCnt > 0) openMberFcltyNvtnsPopup();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const openMberFcltyNvtnsPopup = () => {
  const popupOpts = {
    header: '시설 초대 내역',
    contentStyle: {
      'width': '650px',
    }
  }

  $popup.show(MberFcltyNvtns, popupOpts);
}

const openFcltSvcPopup = ({fcltySn}) => {
  const popupOpts = {
    header: '시설 및 서비스',
    contentStyle: {
      'width': '1200px',
      'max-height': '660px',
      'overflow': 'auto',
      'background': '#f2f4f8'
    }
  };

  const props = { fcltySn };

  $popup.show(MyHome, popupOpts, props);
}

const btnLgout_click = async () => {
  try {
    $loading.on();

    await $axios.post('/api/cmmn/user-lgout');
    $mber.clear();
    await $alert('로그아웃 되었습니다.');

  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

// 세로이실행 click
const btnSeroiExec_click = async () => {
  try {
    $loading.on();
    const fcltys = await getFcltysByMberSn();
    const fcltyCnt = fcltys.length;

    if (fcltyCnt == 1) {
      const fcltySn = fcltys[0].fcltySn;
      await execSeroi({fcltySn});
    } else $cmmnPopup.fcltyChocShow(execSeroi);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const getFcltySvcUseDlByFcltySnSvcId = async (svcId, fcltySn) => {
  const params = {svcId, fcltySn};
  const {data} = await $axios.get('/api/svc/fclty-svc-use-dl/by-fclty-sn-svc-id', {params});
  return data;
};

const getFcltyStmnAgncyCnsgDlByFcltySn = async (fcltySn) => {
  const params = {fcltySn};
  const {data} = await $axios.get('/api/svc/fclty-stmn-agncy-cnsg-dl/by-fclty-sn', {params});
  return data;
};

// const getFcltyBsisDatPrcsByFcltySn = async (fcltySn) => {
//   const params = {fcltySn};
//   const {data} = await $axios.get('/api/svc/fclty-bsis-dat-prcs/by-fclty-sn', {params});
//   return data;
// };

const execSeroi = async ({fcltySn}) => {
  try {
    $loading.on();
    const svcId = $cmmn.svc.getSeroiSvcId();
    const svcUseDl = await getFcltySvcUseDlByFcltySnSvcId(svcId, fcltySn);
    const isSvcStpg = svcUseDl.svcStpgAt == 'Y';

    if (isSvcStpg) {
      await $alert('서비스 중지 상태입니다.');
      return false;
    }

    // const [ stmnAncyCnsgDl, bsisDatPrcs ] = await Promise.all([getFcltyStmnAgncyCnsgDlByFcltySn(fcltySn), getFcltyBsisDatPrcsByFcltySn(fcltySn)]);
    const stmnAncyCnsgDl = await getFcltyStmnAgncyCnsgDlByFcltySn(fcltySn);
    const stmnAgncyCnsgStcd = stmnAncyCnsgDl.stmnAgncyCnsgStcd;
    // const bsisDatPrstCd = bsisDatPrcs.bsisDatPrstCd;

    // if (stmnAgncyCnsgStcd == '300' && bsisDatPrstCd == '300') {
    if (stmnAgncyCnsgStcd != '100') {
      await $axios.post('/api/cmmn/mber-session/fclty-sn', {fcltySn});

      const url = '/hr/views';
      const hrWindow = window.open('', 'seroi-hr');
      const isExist = hrWindow.location.href != 'about:blank' && !hrWindow.closed;

      hrWindow.location.href = url;

      if (isExist) hrWindow.focus();
    } else {
      const popupOpts = {
        header: '세로이 서비스 신청 대기',
        contentStyle: {
          'width': '770px',
          'max-height': '660px',
        }
      };

      const props = { fcltySn };

      $popup.show(SeroiSvcWait, popupOpts, props);
    }
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}
</script>

<style scoped></style>
